(() => {
  let requested = false;
  let retryTimer = null;

  const tryLoadCarousel = (retriesLeft = 40) => {
    if (requested || !document.querySelector('.jdgm-videos-carousel')) return;

    if (window.jdgm && typeof window.jdgm.loadScript === 'function' && typeof window.jdgm.docReady === 'function') {
      requested = true;
      window.jdgm.docReady(() => window.jdgm.loadScript('video_carousel.js'));
      return;
    }

    if (retriesLeft > 0) {
      retryTimer = window.setTimeout(() => tryLoadCarousel(retriesLeft - 1), 250);
    }
  };

  const activate = () => {
    window.clearTimeout(retryTimer);
    tryLoadCarousel();
  };

  const watch = () => {
    const carousel = document.querySelector('.jdgm-videos-carousel');
    if (!carousel) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          activate();
        }
      }, { rootMargin: '800px 0px', threshold: 0.01 });
      observer.observe(carousel);
    } else {
      activate();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', watch);
})();

(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const hydrate = (img) => {
    if (!img || !img.dataset.secondarySrc) return;
    if (img.dataset.secondarySrcset) img.srcset = img.dataset.secondarySrcset;
    img.src = img.dataset.secondarySrc;
    img.removeAttribute('data-secondary-src');
    img.removeAttribute('data-secondary-srcset');
  };

  const prepareCard = (event) => {
    const card = event.target.closest?.('.card-wrapper, .card');
    if (card) hydrate(card.querySelector('img[data-secondary-src]'));
  };
  document.addEventListener('pointerover', prepareCard, { passive: true });
  document.addEventListener('focusin', prepareCard);

  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrate(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '200px 0px' })
    : null;

  const watch = () => {
    document.querySelectorAll('img[data-secondary-src]').forEach((img) => {
      if (!observer) {
        hydrate(img);
      } else if (!observed.has(img)) {
        observed.add(img);
        observer.observe(img);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();
